import { fetcher } from '@commenda/utils';
import {
  AM_TP_DEMO_ROUTES,
  TAmDemoFinalizeFarRequest,
  TAmDemoFinalizeFarResponse,
  TAmDemoResult,
} from './types';

/**
 * Finalizes the functional analysis and ticks its prerequisite layer on the US local file.
 *
 * Germany's functional-analysis layer is a separate one, completed from inside the German checklist by its own
 * transcript upload. Call `useInvalidateAmTpDemo()` afterwards so the local-file screen reflects the change.
 */
export async function finalizeAmTpDemoFarAnalysis(
  body: TAmDemoFinalizeFarRequest
): Promise<TAmDemoResult<TAmDemoFinalizeFarResponse>> {
  try {
    const response = await fetcher(AM_TP_DEMO_ROUTES.finalizeFar, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      return {
        success: false,
        error: 'Failed to finalize the functional analysis',
      };
    }

    return {
      success: true,
      data: (await response.json()) as TAmDemoFinalizeFarResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to finalize the functional analysis',
    };
  }
}
